<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <quantity-unit-form />
  </v-container>
</template>

<script>
import QuantityUnitForm from './_Form'
export default {
  name: 'AdminMasterQuantityUnitNew',
  components: {
    QuantityUnitForm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '数量単位一覧', disabled: false, to: '/admin/masters/quantity_units', exact: true },
        { text: '数量単位追加', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
